import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import styles from "../../styles/components/qcawaitingrejectedtable.module.scss";
import React from "react";
import EyeTableIcon from "../../public/assets/icons/EyeTableIcon";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";

import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcDateTimeTwo,
  getUtcTime,
  roleFinder,
} from "../../lib/functions/utils.lib";
import PaginationTwo from "../UtilitiesComponent/PaginationTwo";
import VideoPageFullModal from "../VideoPages/pages/VideoPageFullModal";
import WatchVideoModal from "../VideoPages/pages/WatchVideoModal";
import NoResultTwo from "../NoResult/NoResultTwo";
import Filter from "../Filter/Filter";
import { useState } from "react";

export const QCAwaitingRejectedTable = (props) => {
  const {
    datas,
    handlePageChange,
    page,
    filterActive,
    filtersReset,
    handleTriggreFetch,
    loading,
  } = props;
  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
    handleTriggreFetch();
  };

  const [openModalTwo, setOpenModalTwo] = useState(false);

  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };
  return (
    <Box className={styles.QcApprovedTable}>
      <Box className={styles.custom_scroll}>
        <TableContainer className={styles.tableMain}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell className={styles.vsid}>VSID</TableCell>
                <TableCell className={styles.acqui}>Acquisitor</TableCell>
                <TableCell className={styles.thumb}>Thumbnail</TableCell>
                <TableCell className={styles.title}>title</TableCell>
                <TableCell className={styles.submitter}>
                  Submitter Name
                </TableCell>
                <TableCell className={styles.email}>Email Address</TableCell>
                <TableCell className={styles.youtube}>
                  Submission Date
                </TableCell>

                <TableCell className={styles.confirmed}>Rejected By</TableCell>
                <TableCell className={styles.view} align="center">
                  View
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {datas?.data.map((row, i) => (
                <>
                  <TableRow
                    key={i}
                    className={
                      false
                        ? `${styles.tableActive} ${styles.highlighted}`
                        : `${styles.tableActive}`
                    }
                  >
                    <TableCell className={styles.htt_vsid}>
                      <Box
                        className={
                          row.important
                            ? `${styles.vsidBox} ${styles.important}`
                            : styles.vsidBox
                        }
                      >
                        {row.id}
                      </Box>
                    </TableCell>
                    <TableCell className={styles.acqui}>
                      <Box className={styles.acquiBox}>
                        {row.user?.name} {row.user?.last_name}
                        <p className={styles.table_customer}>
                          {roleFinder(row.user?.role_id)}
                        </p>
                      </Box>
                    </TableCell>
                    <TableCell className={styles.htt_thumb}>
                      <Box className={styles.thumbImg}>
                        <Button onClick={() => onOpenTwo(row.id)}>
                          <figure className={styles.thumb_img}>
                            <img
                              className={styles.thumb_img}
                              src={concatHostAndImagePath(row.thumbnail)}
                            />
                          </figure>
                        </Button>
                      </Box>
                    </TableCell>
                    <TableCell className={styles.title}>
                      <Box className={styles.titleBox}>{row.title}</Box>
                    </TableCell>
                    <TableCell className={styles.submitter}>
                      {row.first_name} {row.last_name}
                    </TableCell>
                    <TableCell className={styles.email}>
                      {row.email}
                      {row.unreachable_submitter ? (
                        <p className={styles.red_email}>Unreachable Email</p>
                      ) : (
                        <></>
                      )}
                    </TableCell>
                    <TableCell className={styles.htt_youtube}>
                      {getUtcDate(row.created_at)} <br />
                      {getUtcTime(row.created_at)}
                    </TableCell>
                    <TableCell className={styles.htt_confirmed}>
                      <Box className={styles.approve_styls}>
                        {row.manager?.name}
                      {row.manager?.last_name}{" "}
                      Manager
                      {getUtcDateTimeTwo(
                        row.video_meta.quality_team_updated_at
                      )}{" "}
                      </Box>
                    </TableCell>
                    <TableCell align="center" className={styles.htt_view}>
                      <Box className={styles.viewIcon}>
                        <Button onClick={() => onOpen(row.id)}>
                          <EyeTableIcon />
                        </Button>
                      </Box>
                    </TableCell>
                    {row?.viewBy === true ? (
                      <>
                        <TableCell className={styles.tdOverlay}>
                          <p>
                            This approved video is currently being verified by a
                            QC Agent.
                          </p>
                        </TableCell>
                      </>
                    ) : null}
                  </TableRow>

                  {/* <TableRow>
                                    <TableCell className={styles.blanktd}></TableCell>
                                    <TableCell className={styles.blanktd}></TableCell>
                                    <TableCell className={styles.blanktd}></TableCell>
                                    <TableCell className={styles.blanktd}></TableCell>
                                    <TableCell className={styles.blanktd}></TableCell>
                                    <TableCell className={styles.blanktd}></TableCell>
                                    <TableCell className={styles.blanktd}></TableCell>
                                    <TableCell className={styles.blanktd}></TableCell>
                                    <TableCell className={styles.blanktd}></TableCell>
                                </TableRow> */}

                  <TableRow className={styles.blnkTd}>
                    <TableCell colSpan={10}>{""}</TableCell>
                  </TableRow>
                </>
              ))}

              {/* No data found */}

              <TableRow>
                {/* <TableCell className={`${styles.no_data_found}`} colSpan={9}>
                                <Box className={styles.no_data_div}>
                                    <Box className={styles.no_data_icon}>
                                        <figure className={styles.no_data_icon}>
                                            <NoDataIcon />
                                        </figure>
                                    </Box>
                                    <Typography variant='body1'>
                                        We couldn’t find any matches for the selected filter(s).
                                    </Typography>
                                    <Box className={styles.btn_holder}>
                                        <Button type='button' className={styles.reset_btn}>
                                            Reset filters
                                        </Button>
                                    </Box>
                                </Box>

                            </TableCell> */}

                {/* <TableCell className={`${styles.no_data_found} ${styles.no_data_found_two}`} colSpan={9}>

                                <Box className={styles.no_data_div}>
                                    <Box className={styles.no_data_icon}>
                                        <figure className={styles.no_data_icon}>
                                            <ErrorTableIcon />
                                        </figure>
                                    </Box>
                                    <Typography variant='body1'>
                                        We couldn't find any videos approved within the specified date range.
                                    </Typography>

                                </Box>
                            </TableCell> */}

                {/* <TableCell className={`${styles.no_data_found} ${styles.no_data_found_three}`} colSpan={9}>
                                <Box className={styles.no_data_div}>
                                    <Box className={styles.no_data_icon}>
                                        <figure className={styles.no_data_icon}>
                                            <ErrorTableIconTwo />
                                        </figure>
                                    </Box>
                                    <Typography variant='body1'>
                                    You have no approved videos pending confirmation at the moment. Please reload the page or check back later.
                                    </Typography>

                                </Box>
                            </TableCell> */}

                {/* <TableCell className={`${styles.no_data_found} ${styles.no_data_found_four}`} colSpan={9}>
                                <Box className={`${styles.no_data_div} `}>

                                    <Typography variant='body1'>
                                    End of list. We couldn't find more approved videos pending confirmation matching your selected filter(s).
                                    </Typography>

                                </Box>
                            </TableCell> */}

                {/* End of data */}
              </TableRow>
              <TableRow className={styles.paginationTble}>
                <TableCell colSpan={10} sx={{ border: "none !important" }}>
                  {datas?.data.length > 0 ? (
                    <>
                      {datas.data.length < datas.per_page &&
                      datas.last_page == 1 ? (
                        <>
                          <p className={styles.endList}>
                            End of list. We couldn't find more videos that match
                            your selected filter(s).
                          </p>
                        </>
                      ) : (
                        <>
                          <PaginationTwo
                            page={page}
                            count={datas?.last_page}
                            handleChange={handlePageChange}
                          />
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <VideoPageFullModal
            onClose={onClose}
            open={openModal}
            id={id}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="videoPageModal"
          />
          <WatchVideoModal
            onClose={onCloseTwo}
            open={openModalTwo}
            id={id}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="videoPageModal"
          />
          {datas?.data.length > 0 ? (
            <></>
          ) : (
            <>
              {filterActive ? (
                <Filter resetFilters={filtersReset} className="qcAwaitingRejected"/>
              ) : (
                <>{!loading && <NoResultTwo heading="approved" />}</>
              )}
            </>
          )}

          {/* <EmptyTable/> */}

          {/* <NoResultTable/> */}

          {/* <TablePagination/> */}
        </TableContainer>
      </Box>
    </Box>
  );
};
